import React from "react";
import { Container } from "react-bootstrap";
import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Scatter } from "react-chartjs-2";


ChartJS.register(
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);




/*
Pass dataList as a prop.
dataList is an array of objects, each object has the following properties:
- xArray: an array of x values
- yArray: an array of y values
- xLabel: a string label for the x axis
- yLabel: a string label for the y axis
- dataLabel: a string label for the data
- color: an array of string colors for the data points
*/

// App Parent Component
const CFIScatterPlot = ({ dataList }) => {
    // dataList = dataList.filter(function( element ) {
    //     return element !== undefined && element.xArray !== undefined;
    //  });
    const COLORS = ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
        '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
        '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
        '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', 
        '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
        '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
        '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
        '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
        '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'];

        
     function getMIN(dataListA) {
        var minArray = [0.0];
        for (var i = 0; i < dataListA.length; i++) {
            // Filter out NaN values before calculating the minimum
            const validYValues = dataListA[i].yArray.filter(value => !isNaN(value));
            if (validYValues.length > 0) {
                minArray.push(Math.min(...validYValues));
            }
        }
        return Math.min(...minArray) - dataListA[0].step;
    }
    function getMAX(dataListA) {
        var minArray = [0.0];
        for (var i = 0; i < dataListA.length; i++) {
            // Filter out NaN values before calculating the maximum
            const validYValues = dataListA[i].yArray.filter(value => !isNaN(value));
            if (validYValues.length > 0) {
                minArray.push(Math.max(...validYValues));
            }
        }
        return Math.max(...minArray) + dataListA[0].step;
    }


    const options = dataList.length > 0 ? {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: dataList[0].title,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: dataList[0].xLabel,
                },
                ticks: {
                    display: true,
                },
                display: true,
            },
            y: {
                title: {
                    display: true,
                    text: dataList[0].yLabel,
                },
                min: getMIN(dataList),
                max: getMAX(dataList),
                stepSize: dataList[0].step,
            },
        },                
        elements: {
          point:{
              radius: 5
          }
        }
    } : {};

    const datasets = [];

    for (const [index, iData] of Object.entries(dataList)) {
        const iDataset = {};
        iDataset.label = iData.dataLabel;
        iDataset.data = iData.yArray;
        iDataset.backgroundColor = iData.color ? iData.color : COLORS.pop();
        datasets.push(iDataset);

    }

    const data = {
        labels: dataList.length > 0 ? dataList[0].xArray : [],
        datasets: datasets
    };
    return (
        <Container>
            <Scatter options={options} data={data} />
        </Container>
    );
};

export default CFIScatterPlot;
